export const theme = {
  direction: 'rtl',
  colors: {
    primary: '#FF6B6B',
    secondary: '#4ECDC4',
    background: '#FFFFFF',
    white: '#FFFFFF',
    text: {
      primary: '#2D3436',
      secondary: '#636E72',
      light: '#FFFFFF',
    },
    surface: {
      light: '#F8F9FA',
      dark: '#343A40',
    },
  },
  fonts: {
    title: "'Heebo', 'Arial', sans-serif",
    body: "'Heebo', 'Arial', sans-serif",
  },
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '2rem',
    lg: '4rem',
    xl: '8rem',
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
  },
  shadows: {
    small: '0 2px 4px rgba(0,0,0,0.1)',
    medium: '0 4px 8px rgba(0,0,0,0.1)',
    large: '0 8px 16px rgba(0,0,0,0.1)',
  },
  titles: {
    home: 'דף הבית',
    about: 'אודות הבלוג',
    guides: 'מדריכים',
    international: 'יעדים בחו״ל',
    israel: 'יעדים בישראל',
    blog: 'מזרח ללא גבולות',
  },
};

export type Theme = typeof theme;
